import { useQuery } from "@tanstack/react-query";
import {
  IMemberLoginHistoryPostModel,
  IMemberStatusCountGridPostModel,
} from "./types";
import api from "./requests";

export function GetMembers(model: IMemberStatusCountGridPostModel) {
  const query = useQuery({
    queryKey: ["getMembers"],
    queryFn: () => api.getMemberStatusCount(model),
  });
  return query;
}

export function GetLogedInMembers(model: IMemberLoginHistoryPostModel) {
  const query = useQuery({
    queryKey: ["getLogedInMembers"],
    queryFn: () => api.getLogedInMembers(model),
  });
  return query;
}

export function GetMemberWiseTables() {
  const query = useQuery({
    queryKey: ["getMemberWiseTableResults"],
    queryFn: () => api.getMemberWiseTables(),
  });
  return query;
}

export function GetIndustryWiseMember() {
  const query = useQuery({
    queryKey: ["getIndustryWiseMember"],
    queryFn: () => api.getIndustryWiseMember(),
  });
  return query;
}
